export default function ContactForm (){
    return(
        <section className="ContactMeFormWrapper">
            <div className="title">Contact Me</div>
            <div className="sub-title">Utilize the contact form to share your questions, feedback, or requests with us. We respond promptly and attentively to every message received. We look forward to hearing from you with pleasure.</div>
            <div className="form-wrapper">
                <form>
                    <div className="row">
                        <div className="name">
                            <label htmlFor="fullname">full name</label>
                            <input type="text" id="fullname" placeholder="Input"></input>
                        </div>
                        <div className="email">
                            <label htmlFor="email">email</label>
                            <input type="email" id="email" placeholder="Input"></input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="subject">
                            <label htmlFor="subject">subject</label>
                            <input type="subject" id="subject" placeholder="Input"></input>
                        </div>
                    </div>
                    <div className="row">
                        <div className="message">
                            <label htmlFor="message">message</label>
                            <textarea id="message" placeholder="Input"></textarea>
                        </div>
                    </div>
                    <div>
                        <button className="btn download-btn btn-icon" >Send message</button>
                    </div>
                </form>
                <span className="form-bubble bubble-1"></span>
                <span className="form-bubble bubble-2"></span>
            </div>
        </section>
    )
}